/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/08/2022
 */

import {gql} from "urql";

export const setSlackTokenMutation = gql`
	mutation SetSlackToken($code: String!, $redirectUri: String!) {
		setUserSlackToken(code: $code, redirectUri: $redirectUri) {
			ok
			error
		}
	}
`;

export interface SetSlackTokenVars {
	code: string
	redirectUri: string
}

export interface SetSlackTokenResponse {
	setUserSlackToken: {
		ok: boolean
		error?: string
	}
}